import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/inspectTask/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/inspectTask/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/inspectTask/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/inspectTask/submit', params, options);

export const update = (params, options) => request.post('/api/inspectTask/submit', params, options);

export const submitTemporaryType = (params, options) =>
  request.post('/api/inspectTask/submitTemporaryType', params, options);

export const updateTaskStatus = (params, options) =>
  request.post('/api/inspectTask/updateTaskStatus', qs.stringify(params), options);

export const selectInspectTime = (params, options) =>
  request.post('/api/inspectTask/selectInspectTime?id=' + params, Object.assign({}, options, {}));
